import Spinner from "./Spinner";

interface CustomVButtonProps {
  status?: string;
  disabled?: boolean;
}

type VButtonProps = CustomVButtonProps & React.ComponentProps<"button">;

const VButton: React.FC<VButtonProps> = ({
  children,
  className,
  status,
  disabled = false,
  ...props
}) => (
  <button
    {...props}
    className={`bg-gray-700 rounded-lg px-5 py-2 disabled:cursor-not-allowed ${className}`}
    disabled={disabled || status === "pending"}
    aria-busy={status === "pending"}
    aria-label={
      props["aria-label"] ??
      (status === "pending" && typeof children === "string"
        ? children
        : undefined)
    }
  >
    {status === "pending" ? <Spinner /> : children}
  </button>
);

export default VButton;
